import axios from 'axios';

export type GetLockboxTypesForListingDTO = {
  supra: boolean;
  masterLock: boolean;
  sentriLock: boolean;
  combinationLockbox: boolean;
};

const getListingLockboxTypes = async (listingId: string) => {
  const { data } = await axios.get<GetLockboxTypesForListingDTO>(
    `/listing/${listingId}/appointments/lockbox_types`,
  );

  return data;
};

export default getListingLockboxTypes;
